import axios from 'axios';

import { constants } from '../Configs/constants';

const { BASE_URL } = constants;

export const API = axios.create({
  baseURL: `${BASE_URL}/api`,
  headers: { 'content-type': 'application/json', accept: 'application/json' },
});

export const query = async (action, payload) => {
  try {
    const response = await action(payload);
    return response;
  } catch (err) {
    console.log(err.message);
    if (err.response) return err.response;
    else return { data: { message: 'Unhandled error.Try again later.' } };
  }
};

export const authQuery = async (
  token,
  action,
  payload,
  type = {},
  controls = {},
) => {
  const config = {
    headers: {
      Authorization: `Bearer ${token}`,
      ...type,
    },
    ...controls,
  };
  try {
    const response = await action(config, payload);
    return response;
  } catch (err) {
    if (err.response) return err.response;
    else
      return {
        data: { message: `Unhandled error: ${err.message}. Try again later.` },
      };
  }
};
